/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All IUPAC nucleotide codes are supported and complemented correctly, for example R (purine) becomes Y (pyrimidine) and N stays N.`)
};

const es_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los códigos de nucleótidos IUPAC son compatibles y se complementan correctamente; por ejemplo, R (purina) se convierte en Y (pirimidina) y N permanece como N.`)
};

const de_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle IUPAC-Nukleotidcodes werden unterstützt und korrekt komplementiert, zum Beispiel wird R (Purin) zu Y (Pyrimidin) und N bleibt N.`)
};

const nl_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle IUPAC-nucleotidecodes worden ondersteund en correct gecomplementeerd, bijvoorbeeld R (purine) wordt Y (pyrimidine) en N blijft N.`)
};

const fr_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les codes nucléotidiques IUPAC sont pris en charge et complémentés correctement, par exemple R (purine) devient Y (pyrimidine) et N reste N.`)
};

const it_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i codici nucleotidici IUPAC sono supportati e complementati correttamente, ad esempio R (purina) diventa Y (pirimidina) e N resta N.`)
};

const pt_br2_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os códigos de nucleotídeos IUPAC são suportados e complementados corretamente — por exemplo, R (purina) se torna Y (pirimidina) e N permanece N.`)
};

const pt_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os códigos de nucleótidos IUPAC são suportados e complementados corretamente; por exemplo, R (purina) torna-se Y (pirimidina) e N permanece N.`)
};

const ja_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのIUPACヌクレオチドコードに対応し、正しく相補化されます。例えばR（プリン）はY（ピリミジン）になり、Nはそのまま Nです。`)
};

const zh_revcomp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有 IUPAC 核苷酸简并码都受支持并能正确互补，例如 R（嘌呤）会变为 Y（嘧啶），N 保持为 N。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_faq_a3", locale)
	if (locale === "en") return en_revcomp_faq_a3(inputs)
	if (locale === "es") return es_revcomp_faq_a3(inputs)
	if (locale === "de") return de_revcomp_faq_a3(inputs)
	if (locale === "nl") return nl_revcomp_faq_a3(inputs)
	if (locale === "fr") return fr_revcomp_faq_a3(inputs)
	if (locale === "it") return it_revcomp_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_faq_a3(inputs)
	if (locale === "pt") return pt_revcomp_faq_a3(inputs)
	if (locale === "ja") return ja_revcomp_faq_a3(inputs)
	return zh_revcomp_faq_a3(inputs)
};